// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".row.grey-lined{border-bottom:1px solid #d9d9d9}footer p{color:#6c6c6c}footer a,footer p{font-weight:400;font-size:12px;line-height:20px}@media only screen and (min-width:768px){footer a,footer p{font-size:14px;line-height:22px}}.sk-logo{display:block;width:156px;height:46px}@media only screen and (max-width:575.98px){.sk-logo{width:114px;height:34px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
